import { Auth } from "aws-amplify"
import FsLightbox from "fslightbox-react"
import Cookies from "js-cookie"
import React, { useEffect, useState } from "react"
import { Image } from "react-datocms"
import ReactMarkdown from "react-markdown"
import { connect } from "react-redux"
import Slider from "react-slick"
import "slick-carousel/slick/slick.css"
import SupplierContact from "./SupplierContact"
import * as styles from "./SupplierDetails.module.scss"
import SupplierFAQs from "./SupplierFAQs"
import SupplierTestimonials from "./SupplierTestimonials"
import { eventGtag } from "@lib/gtag"
import trackFBEvent from "@lib/trackFBEvent"
import trackUser from "@lib/trackUser"
import useMediaQuery from "@lib/useMediaQuery"
import fetchLambda from "@data/fetchLambda"
import lambdas from "@data/lambdas"
import * as actions from "@store/actions"
import AuthenticationModal from "@components/auth/AuthenticationModal/AuthenticationModal"
import Breadcrumbs from "@components/global/Breadcrumbs/Breadcrumbs"
import CurrentParty from "@components/global/CurrentParty/CurrentParty"
import SavedSuppliersModal from "@components/global/SavedSuppliersModal/SavedSuppliersModal"
import SharePageModal from "@components/global/SharePageModal/SharePageModal"
import PostsList from "@components/layouts/blog/PostsList/PostsList"
import ScrollMenu from "@components/layouts/global/ScrollMenu/ScrollMenu"
import Button from "@components/objects/Button/Button"
import TickedList from "@components/objects/TickedList/TickedList"
import Section from "@components/structure/Section/Section"
import SiteWrapper from "@components/structure/SiteWrapper/SiteWrapper"
import SupplierEnquireModal from "@components/supplier/SupplierEnquireModal/SupplierEnquireModal"
import SupplierList from "@components/supplier/SupplierList/SupplierList"
import SupplierSavedNotice from "@components/supplier/SupplierList/SupplierSavedNotice"
import communicationIcon from "@images/icons/communication.svg"
import feesicon from "@images/icons/fees.svg"
import galleryWhite from "@images/icons/galleryWhite.svg"
import giftIcon from "@images/icons/gift.svg"
import homeWhite from "@images/icons/homeWhite.svg"
import hoppIconDark from "@images/icons/hoppIconDark.svg"
import hoppIconWhite from "@images/icons/hoppIconWhite.svg"
import locationIcon from "@images/icons/locationMarkerGrey.svg"
import playButton from "@images/icons/playIcon.svg"
import priceIcon from "@images/icons/priceIcon.svg"
import saveStar from "@images/icons/saveStar.svg"
import saveStarWhite from "@images/icons/saveStarWhite.svg"
import sustainabilityIcon from "@images/icons/sustainability.svg"
import tickPink from "@images/icons/tickPink.svg"
import worksAbroadIcon from "@images/icons/worksAbroadIcon.svg"
import noImage from "@images/noImage.png"
import noImageSquare from "@images/noImageSquare.png"

const { PARTY_SUPPLIER_SUBMIT } = lambdas[process.env.NEXT_PUBLIC_ENV]

const SupplierDetails = ({
  isAuthenticated,
  currentParty,
  supplier,
  similarSuppliers,
  emptySuppliers,
  partySaveMessageUpdate,
  partyUpdate,
  search,
  featuredBlogs,
  savingSupplierMessage,
  partyGeneratedSuppliersChange,
  lockSite,
}) => {
  const [isLightBoxOpen, updateIsLightBoxOpen] = useState(false)
  const [showVideo, updateShowVideo] = useState(false)
  const [states, updateStates] = useState(["Select Status", "Contacted", "Confirmed"])
  const [savedStatus, updateSavedStatus] = useState()
  const [savedNote, updateSavedNote] = useState()

  //Resize control
  const isMobile = useMediaQuery(1099)

  const toggleLightbox = () => {
    updateIsLightBoxOpen(!isLightBoxOpen)
  }

  const scrollToSection = (id) => {
    window.scroll({
      top: document.getElementById(id).offsetTop - 70,
      behavior: "smooth",
    })
  }

  const toggleSaveToParty = async (party) => {
    const currParty = currentParty && currentParty.partyId ? { ...currentParty } : party

    const isSaved = !!(currParty && currParty.savedSuppliers
      ? currParty.savedSuppliers.find((savedSupplier) => savedSupplier.id === supplier.id)
      : false)

    const data = {
      createdAt: currParty.partyId,
      supplierId: supplier.id,
      isAdding: !isSaved,
    }

    const user = await Auth.currentSession()

    const response = await fetchLambda(PARTY_SUPPLIER_SUBMIT, {
      sessionToken: user.getIdToken().getJwtToken(),
      data: data,
    })

    if (response.ok) {
      const currSupplier = supplier

      partySaveMessageUpdate({
        isSaving: !isSaved,
        supplierImage: currSupplier.coverphoto
          ? currSupplier.coverphoto.url + "?w=120&h=120&fit=crop&fm=jpg"
          : noImageSquare,
        partyName: currParty.partyName,
      })

      //analytics
      eventGtag({
        action: !isSaved ? "Saved" : "Removed",
        params: {
          event_category: "Supplier",
          event_label: currSupplier.name,
          value: currSupplier.id,
        },
      })
      if (!isSaved) trackFBEvent("AddToWishlist")

      let savedSuppliers = []

      if (!isSaved) {
        const currSupplierInfo = response.data.result.savedSuppliers.find((el) => el.id == currSupplier.id)
        const newSupplier = {
          coverphoto: currSupplier.coverphoto,
          description: currSupplier.description,
          id: currSupplier.id,
          name: currSupplier.name,
          pricerange: currSupplier.pricerange,
          slug: currSupplier.slug,
          supplierNote: currSupplierInfo.supplierNote,
          supplierStatus: currSupplierInfo.supplierStatus,
          supplierservices: currSupplier.supplierservices,
          email: currSupplier.email,
          stripeId: currSupplier.stripeId,
          stripeStatus: currSupplier.stripeStatus,
          stripeTrialEnd: currSupplier.stripeTrialEnd,
          createdby: currSupplier.createdby,
        }
        savedSuppliers =
          currParty.savedSuppliers && currParty.savedSuppliers.length
            ? [...currParty.savedSuppliers, newSupplier]
            : [newSupplier]
      } else {
        savedSuppliers = currParty.savedSuppliers.filter((supplier) =>
          response.data.result.savedSuppliers.some((savedSupplier) => savedSupplier.id == supplier.id)
        )
      }

      partyGeneratedSuppliersChange(false)

      partyUpdate({ ...currParty, savedSuppliers })
    }
  }

  const updateStatus = async (newStatus) => {
    const data = {
      createdAt: currentParty.partyId,
      supplierId: supplier.id,
      status: newStatus ? newStatus : 0,
      isUpdatingStatus: true,
    }

    const user = await Auth.currentSession()

    const response = await fetchLambda(PARTY_SUPPLIER_SUBMIT, {
      sessionToken: user.getIdToken().getJwtToken(),
      data: data,
    })

    if (response.ok) {
      updateSavedStatus(newStatus)
      const savedSuppliers = currentParty.savedSuppliers.map((savedSupplier) => {
        return savedSupplier.id === supplier.id ? { ...savedSupplier, supplierStatus: newStatus } : savedSupplier
      })
      partyUpdate({ ...currentParty, savedSuppliers })

      //analytics
      eventGtag({
        action: "Update",
        params: {
          event_category: "Supplier Status",
          event_label: supplier.name,
          value: supplier.id,
        },
      })
    }
  }

  const initialLoad = async () => {
    //analytics
    eventGtag({
      action: "Page View",
      params: {
        event_category: "Supplier",
        event_label: supplier.name,
        value: supplier.id,
      },
    })

    trackUser("countSupplierPageView")

    const savedData =
      currentParty && currentParty.savedSuppliers
        ? currentParty.savedSuppliers.find((savedSupplier) => savedSupplier.id === supplier.id)
        : false

    updateSavedStatus(savedData && savedData[0] && savedData[0].supplierStatus ? savedData[0].supplierStatus : 0)
    updateSavedNote(savedData && savedData[0] ? savedData[0].supplierNote : "")

    //recent viewed
    const currentId = "" + supplier.id
    const recentlyViewedHoppSuppliers = JSON.parse(localStorage.getItem("recentlyViewedHoppSuppliers"))

    let updatedRecentlyViewedHoppSuppliers = []

    if (!recentlyViewedHoppSuppliers || (recentlyViewedHoppSuppliers && recentlyViewedHoppSuppliers.length === 0)) {
      // console.log('empty')
      updatedRecentlyViewedHoppSuppliers = [currentId]
    } else if (recentlyViewedHoppSuppliers.indexOf(currentId) === -1) {
      // console.log('not empty, not found')
      if (recentlyViewedHoppSuppliers.length < 4) {
        // console.log('not empty, not found, prepending')
        updatedRecentlyViewedHoppSuppliers = [currentId, ...recentlyViewedHoppSuppliers]
      } else {
        // console.log('not empty, not found, replacing last')
        updatedRecentlyViewedHoppSuppliers = [
          currentId,
          ...recentlyViewedHoppSuppliers.splice(0, recentlyViewedHoppSuppliers.length - 1),
        ]
      }
    } else {
      // console.log('not empty, found, replacing self')
      updatedRecentlyViewedHoppSuppliers = [
        currentId,
        ...recentlyViewedHoppSuppliers.filter((supplier) => supplier !== currentId),
      ]
    }

    //popup signup prompt after 2 suppliers profiles clicked on
    if (
      !Cookies.get("hopp_newsletter") &&
      recentlyViewedHoppSuppliers &&
      updatedRecentlyViewedHoppSuppliers.length > 2
    ) {
      localStorage.setItem("hoppViewLimit", 1)
      if (isAuthenticated === false) {
        lockSite(true)
      }
    }

    localStorage.setItem("recentlyViewedHoppSuppliers", JSON.stringify(updatedRecentlyViewedHoppSuppliers))
  }

  useEffect(() => {
    initialLoad()
  }, [])

  let offer = null

  if (supplier.offer && supplier.offer != "0") {
    offer = `save **${supplier.offer}%** with HOPP`
  }

  if (supplier.offerother) {
    offer = supplier.offerother
  }

  let priceRangeLabel = ""
  for (let i = 1; i <= supplier.pricerange; i++) {
    priceRangeLabel += "£"
  }

  const unsavedButtonStyles = {
    image: saveStar,
    design: "outline",
    color: "dark",
    text: "Save to party",
    type: "button",
    onClick: toggleSaveToParty,
  }

  const saveButton = (
    currentParty && currentParty.savedSuppliers
      ? currentParty.savedSuppliers.find((savedSupplier) => savedSupplier.id === supplier.id)
      : false
  ) ? (
    <Button image={saveStarWhite} design="solid" color="pink" text="Saved" type="button" onClick={toggleSaveToParty} />
  ) : (
    <Button {...unsavedButtonStyles} />
  )

  const primaryService =
    supplier.supplierservices && supplier.supplierservices.length ? supplier.supplierservices[0].service : ""

  const isVirtual =
    supplier.suppliercategory && supplier.suppliercategory.length && supplier.suppliercategory.find((el) => el.virtual)

  const mainActions = (
    <div className={styles.mainActions}>
      <SupplierEnquireModal
        button={{ text: "Find out more", color: "pink" }}
        supplierName={supplier.name}
        supplierId={supplier.id}
        supplierCreatedby={supplier.createdby}
        supplierStripeId={supplier.stripeId}
        supplierStripeStatus={supplier.stripeStatus}
        supplierStripeTrialEnd={supplier.stripeTrialEnd}
        supplierService={supplier.supplierservices[0]?.id}
        supplierServiceLabel={supplier.supplierservices[0]?.service}
        data={{
          addresscity: supplier.addresscity,
          addresspostcode: supplier.addresspostcode,
          addressstreet1: supplier.addressstreet1,
          addressstreet2: supplier.addressstreet2,
          contactname: supplier.contactname,
          email: supplier.email,
          phone: supplier.phone,
          website: supplier.website,
          offer: supplier.offer,
          offerother: supplier.offerother,
        }}
        facebook={supplier.facebook}
        twitter={supplier.twitter}
        instagram={supplier.instagram}
        linkedin={supplier.linkedin}
        updateStatus={updateStatus}
      />

      {currentParty && currentParty.partyId ? (
        saveButton
      ) : (
        <AuthenticationModal
          defaultStep="createParty"
          supplierID={supplier.id}
          toggleSaveToParty={toggleSaveToParty}
          button={{ ...unsavedButtonStyles }}
        />
      )}
    </div>
  )

  const floatingIntro = (
    <div className={styles.floatingIntro}>
      {supplier.hoppRecommended && (
        <h3 className={styles.hoppRecommended}>
          <img src={hoppIconWhite} alt="" />
          HOPP RECOMMENDED
        </h3>
      )}

      {isVirtual ? (
        <h3 className={styles.virtualLabel}>
          <img src={homeWhite} alt="" />
          {supplier.bundle ? "Virtual Bundle" : "Virtual Supplier"}
        </h3>
      ) : null}
      <SiteWrapper mobileOnly className={styles.inner}>
        {supplier.internalnote && (
          <div className={styles.hoppNote}>
            <h3>
              <img src={hoppIconDark} alt="Location" />A Note from HOPP
            </h3>
            <p>{supplier.internalnote}</p>
          </div>
        )}

        {/* Discount */}
        {offer && (
          <div className={styles.discount}>
            <h3>
              <span className={styles.discountImg}>
                <img src={hoppIconWhite} alt="Reward" />
              </span>
              HOPP Reward
            </h3>
            <ReactMarkdown>{offer}</ReactMarkdown>
          </div>
        )}

        {mainActions}

        <div className={styles.icons}>
          <ul>
            <li>
              <img src={feesicon} alt="" />
              No booking fees
            </li>
            <li>
              <img src={communicationIcon} alt="" />
              Direct communication with suppliers
            </li>
            <li>
              <img src={giftIcon} alt="" />
              Exclusive rewards for people who party!
            </li>
          </ul>
        </div>
      </SiteWrapper>
      <div className={styles.social}>
        <SiteWrapper mobileOnly>
          <h3>Need a hand?</h3>
          <p>
            <a href="mailto:hello@houseofpartyplanning.com">
              Get in touch with our <br />
              HOPP Party experts for free advice
            </a>
          </p>
          <SharePageModal />
        </SiteWrapper>
      </div>
    </div>
  )

  const removeDuplicates = (myArr, prop) => {
    return myArr.filter((obj, pos, arr) => {
      return arr.map((mapObj) => mapObj[prop]).indexOf(obj[prop]) === pos
    })
  }

  // Removing duplicates
  const services = supplier.supplierservices ? removeDuplicates(supplier.supplierservices, "id") : null
  const subservices = supplier.suppliersubservices ? removeDuplicates(supplier.suppliersubservices, "id") : null
  const style = supplier.supplierstyle ? removeDuplicates(supplier.supplierstyle, "id") : null
  const features = supplier.supplierfeature ? removeDuplicates(supplier.supplierfeature, "id") : null

  let standingCapacity = null
  let seatedCapacity = null

  if (services && services.some((service) => service.service === "Venue")) {
    standingCapacity = (
      <div className={styles.item} key={"standing"}>
        <span>Standing Capacity</span>
        <p>{supplier.standingcapacity}</p>
      </div>
    )

    seatedCapacity = (
      <div className={styles.item} key={"sitting"}>
        <span>Seated Capacity</span>
        <p>{supplier.seatedcapacity}</p>
      </div>
    )
  }

  const coverphoto = supplier.coverphoto ? (
    <Image data={supplier.coverphoto.responsiveImage} />
  ) : (
    <img src={noImage} alt={supplier.title} />
  )

  //setup video url
  let url = supplier.coverVideo ? supplier.coverVideo.url : ""
  if (supplier.coverVideo) {
    if (supplier.coverVideo.provider === "vimeo") {
      url = `https://player.vimeo.com/video/${supplier.coverVideo.providerUid}?title=0&byline=0&portrait=0`
    }
    if (supplier.coverVideo.provider === "youtube") {
      url = `https://www.youtube.com/embed/${supplier.coverVideo.providerUid}?rel=0`
    }
    if (supplier.coverVideo.provider === "facebook") {
      url = `https://www.facebook.com/plugins/video.php?href=https%3A%2F%2Fwww.facebook.com%2Ffacebook%2Fvideos%2F${supplier.coverVideo.providerUid}%2F&show_text=0`
    }
  }

  // image or video
  const coverElement = supplier.coverVideo ? (
    <div className={`${styles.video} ${showVideo ? styles.active : ""}`}>
      <div className={styles.poster}>
        {coverphoto}
        <div className={styles.playButton} onClick={(e) => updateShowVideo(true)}>
          <img src={playButton} alt="play video" />
        </div>
      </div>
      <iframe
        title={supplier.coverVideo.title}
        src={url}
        frameBorder="0"
        allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture; autoplay; fullscreen"
        scrolling="no"
        allowFullScreen
      ></iframe>
    </div>
  ) : (
    coverphoto
  )

  const currParams = search
  const urlParams = Object.keys(currParams)
    .map(
      (k) =>
        `${encodeURIComponent(k)}=${typeof currParams[k] === "object" ? JSON.stringify(currParams[k]) : currParams[k]}`
    )
    .join("&")

  const supplierPartners =
    supplier.supplierPartners &&
    supplier.supplierPartners.length &&
    supplier.supplierPartners.map((el) => ({ ...el, id: el.id }))

  const websitePattern = new RegExp("^(https?|ftp)://")
  let website = supplier.website
  if (supplier.website && !websitePattern.test(website)) {
    website = "http://" + website
  }

  const handleScrollMenuClick = (e) => {
    const val = e.target.innerText
    const element = document.getElementById(val.toLowerCase())
    if (element) {
      const yOffset = -70
      const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset
      window.scrollTo({ top: y, behavior: "smooth" })
    }
  }

  return (
    <div className={`${styles.SupplierDetails} ${isVirtual ? styles.isVirtual : ""}`}>
      <SiteWrapper desktopOnly>
        {/* Header */}
        <div className={styles.header}>
          <SiteWrapper className={styles.headerBar} mobileOnly>
            <Breadcrumbs color="dark" elements={[["Suppliers Search", "/suppliers-search"], supplier.name]} />
            {currentParty && currentParty.partyId ? (
              <CurrentParty
                currentParty={currentParty}
                currentSearchCategory={search.category}
                className={styles.CurrentParty}
                party={currentParty.partyName}
                color={isMobile ? "light" : "dark"}
              />
            ) : null}
          </SiteWrapper>
          <SiteWrapper mobileOnly>
            <div className={styles.subtitle}>
              <span className={styles.category}>
                {supplier.overwriteService && supplier.overwriteService.length
                  ? supplier.overwriteService
                  : primaryService}
              </span>
              {/* <span className={styles.price}>{priceRangeLabel}</span> */}
            </div>
            <div className={styles.title}>
              <h1>{supplier.name}</h1>
            </div>
            <span className={styles.location}>
              <img src={locationIcon} alt="Location" />
              <span>{supplier.overwriteLocation ? supplier.overwriteLocation : supplier.addresscity}</span>
            </span>
          </SiteWrapper>
        </div>

        <section className={styles.content}>
          <main>
            {/* Gallery */}
            <div className={styles.image}>
              {supplier.photos && supplier.coverphoto ? (
                <FsLightbox
                  className={styles.lightBox}
                  toggler={isLightBoxOpen}
                  sources={[
                    supplier.coverphoto.responsiveImage.src + "?w=2000&fit=clip&fm=jpg",
                    ...supplier.photos
                      .filter((image) => {
                        return image.photo
                      })
                      .map((image) => image.photo.responsiveImage.src + "?w=2000&fit=clip&fm=jpg"),
                  ]}
                />
              ) : null}
              {supplier.photos ? (
                <Slider infinite={false}>
                  <div onClick={!supplier.coverVideo ? toggleLightbox : null}>{coverElement}</div>
                  {supplier.photos.map((image, i) => {
                    if (image.photo) {
                      return (
                        <div onClick={toggleLightbox} key={"image " + i}>
                          <Image data={image.photo.responsiveImage} lazyLoad={false} />
                        </div>
                      )
                    } else {
                      return null
                    }
                  })}
                </Slider>
              ) : (
                coverElement
              )}

              <span className={styles.viewGallery} onClick={toggleLightbox}>
                <img src={galleryWhite} alt="View Gallery" />
              </span>
            </div>

            {isMobile && floatingIntro}

            <SiteWrapper mobileOnly>
              {/* Useful information - worksAbroad */}
              {supplier.worksAbroad || supplier.dayrate || supplier.pricesstartingfrom ? (
                <Section inner id="useful" className={styles.useful}>
                  <h3>Useful information</h3>
                  <div className={styles.list}>
                    {supplier.pricesstartingfrom ? (
                      <div className={styles.item}>
                        <span>
                          <img src={priceIcon} alt="" />
                          What do prices start from?
                        </span>
                        <p>{supplier.pricesstartingfrom}</p>
                      </div>
                    ) : null}
                    {supplier.dayrate ? (
                      <div className={styles.item}>
                        <span>
                          <img src={priceIcon} alt="" />
                          What is your day rate?
                        </span>
                        <p>{supplier.dayrate}</p>
                      </div>
                    ) : null}
                    {supplier.worksAbroad ? (
                      <div className={styles.item}>
                        <span>
                          <img src={worksAbroadIcon} alt="" />
                          Works Abroad
                        </span>
                        <p>We have experience doing events outside the UK.</p>
                      </div>
                    ) : null}
                  </div>
                </Section>
              ) : null}

              {/* services */}
              {services && services.length ? (
                <Section inner id="services" className={styles.borderTop}>
                  <section className={styles.services}>
                    <h3>Services</h3>
                    <div className={styles.list}>
                      {services.map((item, i) => (
                        <div className={styles.item} key={"service" + i}>
                          <span>{item.service}</span>
                          {item.iconActive ? <img src={item.icon.url} alt="tick" /> : null}
                        </div>
                      ))}
                    </div>
                  </section>
                </Section>
              ) : null}

              {/* Specifics */}
              {subservices && subservices.length ? (
                <Section inner id="specifics" className={styles.borderTop}>
                  <TickedList tick={tickPink} list={subservices} title="Specific Details" />
                </Section>
              ) : null}

              {/* about */}
              <Section inner id="about" className={`${styles.about} ${styles.borderTop}`}>
                <h3>{isVirtual ? "About" : "About the company"}</h3>
                <ReactMarkdown>{supplier.description}</ReactMarkdown>
              </Section>

              {/* styles */}
              {style && style.length ? (
                <Section inner id="style" className={`${styles.style} ${styles.borderTop}`}>
                  <h3>Style</h3>
                  <div className={styles.list}>
                    {style.map((item, i) => (
                      <div className={styles.item} key={"style" + i}>
                        {item.image ? <img src={`${item.image.url}?w=300&h=200&fit=crop&fm=jpg`} alt="tick" /> : null}
                        <span>{item.style}</span>
                      </div>
                    ))}
                  </div>
                </Section>
              ) : null}

              {/* Custom Section */}
              {supplier.customSection && supplier.customSection.length
                ? supplier.customSection.map((section, i) => (
                    <Section inner className={styles.borderTop}>
                      <h3>{section.title}</h3>
                      <div className={styles.customSection}>
                        <ReactMarkdown>{section.content}</ReactMarkdown>
                      </div>
                    </Section>
                  ))
                : null}

              {/* Additional */}
              {features && features.length ? (
                <Section id="additional" inner className={styles.borderTop + " " + styles.additional}>
                  <h3>Additional Information</h3>
                  <div className={styles.items}>
                    {features.map((item, i) => (
                      <div className={styles.item} key={"features" + i}>
                        <span>{item.feature}</span>
                        <img src={tickPink} alt="tick" />
                      </div>
                    ))}
                    {standingCapacity}
                    {seatedCapacity}
                    {supplier.publicliabilityinsurance ? (
                      <div className={styles.item} key={"publicliabilityinsurance"}>
                        <span>Do you have public liability insurance?</span>
                        <img src={tickPink} alt="tick" />
                      </div>
                    ) : null}
                    {supplier.howlonginthebusiness ? (
                      <div className={styles.item} key={"howlonginthebusiness"}>
                        <span>When was the company started?</span>
                        <p>{supplier.howlonginthebusiness}</p>
                      </div>
                    ) : null}
                    <div className={styles.item} key={"vatregistered"}>
                      <span>Are you VAT registered?</span>
                      {supplier.vatregistered ? <img src={tickPink} alt="tick" /> : <p>No</p>}
                    </div>
                  </div>
                </Section>
              ) : null}

              {/* Sustainability */}
              {supplier.sustainability ? (
                <Section inner id="sustainability" className={styles.borderTop + " " + styles.about}>
                  <h3>
                    <img src={sustainabilityIcon} alt="" />
                    Sustainability
                  </h3>
                  <ReactMarkdown>{supplier.sustainability}</ReactMarkdown>
                </Section>
              ) : null}

              {/* FAQs */}
              {supplier.faqs && supplier.faqs.length ? (
                <Section id="faqs" inner className={styles.borderTop + " " + styles.faqs}>
                  <h3>FAQ's</h3>
                  <SupplierFAQs elements={supplier.faqs} />
                </Section>
              ) : null}

              {/* Testimonials */}
              {supplier.testimonials && supplier.testimonials.length ? (
                <Section id="testimonials" inner className={styles.borderTop + " " + styles.testimonials}>
                  <SupplierTestimonials isMobile={isMobile} elements={supplier.testimonials} />
                </Section>
              ) : null}

              {/* Featured Articles */}
              {featuredBlogs && featuredBlogs.length ? (
                <Section id="articles" inner className={styles.borderTop + " " + styles.faqs}>
                  <h3>Featured Articles</h3>
                  <PostsList thumbnailSize posts={featuredBlogs} />
                </Section>
              ) : null}

              <SupplierContact
                supplierName={supplier.name}
                supplierId={supplier.id}
                data={{
                  addresscity: supplier.addresscity,
                  addresspostcode: supplier.addresspostcode,
                  addressstreet1: supplier.addressstreet1,
                  addressstreet2: supplier.addressstreet2,
                  contactname: supplier.contactname,
                  email: supplier.email,
                  phone: supplier.phone,
                  website: website,
                  discount: supplier.offer || supplier.offerother,
                }}
                facebook={supplier.facebook}
                twitter={supplier.twitter}
                instagram={supplier.instagram}
                linkedin={supplier.linkedin}
              />
            </SiteWrapper>
          </main>
          {!isMobile && <aside>{floatingIntro}</aside>}
        </section>
      </SiteWrapper>
      {/* Similar Suppliers */}
      <Section inner className={styles.similarSuppliers}>
        <SiteWrapper>
          <h3>{supplier.bundle ? "Suppliers included in bundle" : "Suppliers you may be interested in..."}</h3>
          <SupplierList
            viewStyle="grid"
            isSlider
            suppliers={supplierPartners ? supplierPartners : similarSuppliers}
            empty={emptySuppliers}
          />
        </SiteWrapper>
      </Section>
      <SavedSuppliersModal currentParty={currentParty} />
      <SupplierSavedNotice {...savingSupplierMessage} />
      {!isMobile && (
        <ScrollMenu title="Supplier Info">
          <ul className={styles.scrollmenu} onClick={handleScrollMenuClick}>
            {supplier.worksAbroad || supplier.dayrate || supplier.pricesstartingfrom ? <li>Useful</li> : null}
            {services && services.length ? <li>Services</li> : null}
            {subservices && subservices.length ? <li>Specifics</li> : null}
            <li>About</li>
            {style && style.length ? <li>Style</li> : null}
            {features && features.length ? <li>Additional</li> : null}
            {supplier.sustainability && <li>Sustainability</li>}
            {supplier.faqs && supplier.faqs.length ? <li>FAQs</li> : null}
            {supplier.testimonials && supplier.testimonials.length ? <li>Testimonials</li> : null}
            {featuredBlogs && featuredBlogs.length ? <li>Articles</li> : null}
            <li>Contact</li>
          </ul>
        </ScrollMenu>
      )}
    </div>
  )
}

const mapStateToProps = (state) => {
  return {
    currentParty: state.party.currentParty,
    savingSupplierMessage: state.party.savingSupplierMessage,
    search: state.search.parameters,
    isAuthenticated: state.auth.isAuthenticated,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    partyUpdate: (party) => dispatch(actions.partyUpdate(party)),
    partyGeneratedSuppliersChange: (hasGeneratedSuppliers) =>
      dispatch(actions.partyGeneratedSuppliersChange(hasGeneratedSuppliers)),
    partySaveMessageUpdate: (message) => dispatch(actions.partySaveMessageUpdate(message)),
    lockSite: (lock) => dispatch(actions.lockSite(lock)),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(SupplierDetails)
